import { render, staticRenderFns } from "./sample_files.vue?vue&type=template&id=871112a4"
import script from "./sample_files.vue?vue&type=script&lang=js"
export * from "./sample_files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports